import { monitor } from '@datadog/browser-core';
import { LifeCycleEventType } from './lifeCycle';
export function startDOMMutationCollection(lifeCycle) {
    var observer;
    if (window.MutationObserver) {
        observer = new MutationObserver(monitor(function () {
            lifeCycle.notify(LifeCycleEventType.DOM_MUTATED);
        }));
        observer.observe(document.documentElement, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
    }
    return {
        stop: function () {
            if (observer) {
                observer.disconnect();
            }
        },
    };
}
//# sourceMappingURL=domMutationCollection.js.map